import {Component, Input, OnChanges, SimpleChanges, ViewChild} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {MatSelect} from "@angular/material/select";
import {InputBaseComponent} from "../../base/input-base.component";
import {equals} from "rambda";


@Component({
  selector: "tva-select",
  templateUrl: "./tv-action-select.component.html",
  styleUrls: ["./tv-action-select.component.css"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TvActionSelectComponent,
    multi: true
  }]
})
export class TvActionSelectComponent extends InputBaseComponent implements OnChanges {
  @Input() items: Array<any>;
  @Input() label: string;
  @Input() header: string;
  @Input() itemLabel: string;
  @Input() itemValue: string;

  @ViewChild(MatSelect) selectList: MatSelect;

  constructor() {
    super();
  }
  ngOnChanges(change: SimpleChanges) {
    if (change['formControl']){
      change['formControl'].currentValue.valueChanges.subscribe( (value) => {
        this.patchValue(value);
      })
    }

    if(change['items']?.currentValue && (this.formControl || change['formControl']) && this.selectList){
      this.patchValue(this.formControl.value)
    }
  }

  getItemValue(item: any): any {
    if (this.itemValue) {
      return item[this.itemValue];
    }
    return item;
  }

  getItemLabel(item: any): any {
    if (this.itemLabel) {
      return item[this.itemLabel]
    }
    return item
  }

  private patchValue(value){
    const index = this.items.findIndex( (item)=> equals(item, value) && !Object.is(item, value));
    if (index >= 0)
      this.items[index] = value;
  }
}
